import { render } from "./ProjectGeneralInfo.vue?vue&type=template&id=3afd01d5&scoped=true"
import script from "./ProjectGeneralInfo.vue?vue&type=script&lang=js"
export * from "./ProjectGeneralInfo.vue?vue&type=script&lang=js"

import "./ProjectGeneralInfo.vue?vue&type=style&index=0&id=3afd01d5&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afd01d5"]])

export default __exports__